import { useState } from "react";
import { useTranslation } from "react-i18next";
import AppButton from "../../../ui/buttons/AppButton";
import OptionLabel from "../../../ui/forms/OptionLabel";
import ModalShell from "../../../ui/overlays/ModalShell";
import { itemKindText } from "../../workflows";

interface CurateKindsDialogProps {
  title: string;
  itemKinds: readonly string[];
  chosen: readonly string[];
  /** The kinds to curate from now on; at least one, or Curate would be off. */
  onSave: (kinds: readonly string[]) => void;
  onClose: () => void;
}

/** The item kinds a group curates (accounts.md GS-2: Curate is granted per kind). */
export default function CurateKindsDialog({ title, itemKinds, chosen, onSave, onClose }: CurateKindsDialogProps) {
  const { t } = useTranslation();
  const [kinds, setKinds] = useState<ReadonlySet<string>>(new Set(chosen));
  const ordered = itemKinds.filter((kind) => kinds.has(kind));
  const all = kinds.size === itemKinds.length;
  return (
    <ModalShell
      title={title}
      onClose={onClose}
      size="md"
      zIndexClassName="z-[60]"
      footer={
        <div className="flex justify-end gap-2">
          <AppButton variant="secondary" size="sm" onClick={onClose}>{t("common.cancel")}</AppButton>
          <AppButton variant="primary" size="sm" disabled={ordered.length === 0} onClick={() => { onSave(ordered); onClose(); }}>{t("access.kinds.save")}</AppButton>
        </div>
      }
    >
      <div className="space-y-2 text-sm">
        <OptionLabel>
          <input type="checkbox" checked={all} onChange={(event) => { setKinds(new Set(event.target.checked ? itemKinds : [])); }} />
          {t("access.kinds.every")}
        </OptionLabel>
        <div className="grid gap-1 sm:grid-cols-2">
          {itemKinds.map((kind) => (
            <OptionLabel key={kind}>
              <input type="checkbox" checked={kinds.has(kind)}
                onChange={(event) => {
                  const next = new Set(kinds);
                  if (event.target.checked) next.add(kind); else next.delete(kind);
                  setKinds(next);
                }} />
              {itemKindText(kind, t)}
            </OptionLabel>
          ))}
        </div>
      </div>
    </ModalShell>
  );
}
